export default __webpack_public_path__ + "static/media/hero-bg-2022-1.40df5def.jpg";